import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RecurrentNeighborhoodsResult } from '../../../state/case/case.state'
import { HttpErrorResponse } from '@angular/common/http'
import { DownloadService } from '../../../shared/services/download.service'
import { ToasterService } from '../../../shared/services/toaster.service'

@Component({
    selector: 'app-recurrent-neighborhoods-result-content',
    templateUrl: './recurrent-neighborhoods-result-content.component.html',
    styleUrls: ['./recurrent-neighborhoods-result-content.component.scss'],
})
export class RecurrentNeighborhoodsResultContent {
    @Input()
    rcnEntry: RecurrentNeighborhoodsResult
    @Output()
    close = new EventEmitter<RecurrentNeighborhoodsResult>()

    constructor(private downloadService: DownloadService, private toaster: ToasterService) {}

    detailsVisible = false

    toggleDetails(): void {
        this.detailsVisible = !this.detailsVisible
    }

    downloadData(): void {
        this.downloadService.downloadRecurrentNeighborhood(this.rcnEntry.download_File).subscribe({
            error: (err: HttpErrorResponse) => {
                this.toaster.httpError(
                    err,
                    `Failed to download recurrent neighborhood ${this.rcnEntry.name}.`
                )
            },
        })
    }
}
